import '../common/_icons';

// import basic from admin
import '.';
